import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
	selector: 'app-menu-skeleton-items',
	standalone: true,
	imports: [CommonModule, IonicModule],
	templateUrl: './menu-skeleton-items.component.html',
	styleUrls: ['./menu-skeleton-items.component.scss']
})
export class MenuSkeletonItemsComponent {
	skeletonItems = new Array(12); // Show 12 skeleton food item cards for fuller loading experience
}